import { Component, OnDestroy, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'lu-toggle-button',
	templateUrl: './lu-toggle-button.component.html',
	styleUrls: ['./lu-toggle-button.component.scss']
})
export class LuToggleButtonComponent extends FieldType implements OnInit, OnDestroy {
	toggleValue: boolean;
	toggleLabel: string;
	icon: string;
	disabled: boolean;
	destroy$: Subject<void> = new Subject<void>();

	ngOnInit(): void {
		this.initToggleButton();
		this.listenToFormChanges();
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	listenToFormChanges(): void {
		this.form.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.resetToggleButtonState());
	}

	resetToggleButtonState(): void {
		if (this.formControl.value == null) {
			const initialConfigValue = this.to?.options[0]?.value;
			this.formControl?.setValue(initialConfigValue);
			this.toggleValue = initialConfigValue;
		} else {
			this.toggleValue = this.formControl.value;
		}
	}

	initToggleButton(): void {
		const options = this.to?.options[0];
		this.icon = this.to?.icon;
		this.toggleLabel = options?.label;
		this.disabled = options?.disabled;

		// If the formControl value is undefined (model is empty), set the value to the first option value
		if (this.formControl.value == undefined) {
			this.toggleValue = options?.value;

			if (!!options?.value) {
				this.toggleValue = options.value;
				this.formControl.setValue(options.value);
			}
		} else {
			this.toggleValue = this.formControl.value;
		}
	}

	toggle(): void {
		this.toggleValue = !this.toggleValue;
		this.formControl.setValue(this.toggleValue);
	}
}
